import palette from '../palette';

export default {
  root: {
    backgroundColor: palette.background.table,
    borderRadius: 4,
    overflow: 'hidden',
  },
};
